import { handleAjaxError } from "./handleAjaxError";
import { updateCredits } from "./updateCredits";
import { TTSManager } from "../../services/tts/index";
import { setPlayIconState } from "./setPlayIconState";
import { updateChatSettings } from "./updateChatSettings";

const $ = jQuery;

let lastMessageId = null;
let lastAudioPlayed = null;
let speechAudioPlayer = {};
let lastClickTime = 0;
const TTS_TRANSIENT_RETRY_DELAYS_MS = [500, 1000, 2000];

function ttsRetryUrl(audioUrl) {
  const separator = audioUrl.includes("?") ? "&" : "?";
  return `${audioUrl}${separator}tts_retry=${Date.now()}`;
}

// 🔹 Enable audio on body click (Safari requires user interaction)
document.addEventListener("click", unlockAudio, { once: true });

jQuery(".g-chatform").each(function () {
  let chatId = jQuery(this).attr("id");
  speechAudioPlayer[chatId] = jQuery(this).find(".speech-audio-player")[0];
});

async function unlockAudio() {
  Object.entries(speechAudioPlayer).map(function (element) {
    element[1].play().catch(function () {});

    setTimeout(function () {
      element[1].pause();
    }, 100);
  });
}

/**
 * @param message
 */
export function playMessage(message) {
  message.click(function (event) {
    event.preventDefault();
    playAudio($(this));
  });
}

/**
 * Automatically play a message via TTS (for auto-play feature)
 * @param {jQuery} messageElement - The .g-chatform-message element
 * @returns {Promise} - Resolves when audio finishes playing
 */
export function autoPlayMessage(messageElement) {
  return new Promise((resolve) => {
    const chatForm = messageElement.closest(".g-chatform");
    const chatId = chatForm.attr("id");
    const messageId = messageElement.attr("data-id");
    const playIcon = messageElement.find(".g-chatform-message-play");

    if (!messageId) {
      console.warn("autoPlayMessage: No message ID found");
      resolve();
      return;
    }

    console.log("autoPlayMessage: Starting TTS for message", messageId);

    // Note: is-playing class is managed by speakKokoroText (added when audio starts, removed when done)
    const selectedVoice = chatForm.find('select[name="tts_model_used"]').val();

    if (TTSManager.supports(selectedVoice)) {
      const rawText = messageElement.attr("data-raw-text");
      if (rawText && rawText.trim().length > 0) {
        console.log("autoPlayMessage: Queuing audio via TTSManager");
        TTSManager.queueText(rawText.trim(), playIcon, resolve, selectedVoice);
        return;
      }
    }

    jQuery.ajax({
      url: growtype_chat_ajax.url,
      type: "post",
      data: {
        message_id: messageId,
        action: growtype_chat_ajax.play_message_action,
        nonce: growtype_chat_ajax.nonce,
      },
      success: function (response) {
        if (
          response.data &&
          response.data.audios &&
          response.data.audios.length > 0
        ) {
          console.log("autoPlayMessage: Playing audio via backend");
          playAudiosSequentiallyWithCallback(
            response.data.audios,
            chatId,
            playIcon,
            resolve
          );
        } else {
          console.warn("autoPlayMessage: No audio returned");
          setPlayIconState(playIcon, false);
          resolve();
        }
      },
      error: function (response) {
        console.error("autoPlayMessage: AJAX error", response);
        setPlayIconState(playIcon, false);
        resolve();
      },
    });
  });
}

/**
 * Play audios sequentially and call callback when done
 * @param {Array} audios - Array of audio URLs
 * @param {string} chatId - The chat form ID
 * @param {jQuery} playIcon - The play icon element to toggle is-playing class
 * @param {Function} callback - Callback when all audios finish
 */
function playAudiosSequentiallyWithCallback(
  audios,
  chatId,
  playIcon,
  callback,
  retryCount = 0
) {
  if (audios.length === 0) {
    setPlayIconState(playIcon, false);
    callback();
    return;
  }

  const audioPlayer = speechAudioPlayer[chatId];
  if (!audioPlayer) {
    console.warn("autoPlayMessage: No audio player found for chat", chatId);
    setPlayIconState(playIcon, false);
    callback();
    return;
  }

  const audioUrl = retryCount > 0 ? ttsRetryUrl(audios[0]) : audios[0];
  audioPlayer.src = audioUrl;
  audioPlayer.volume = 1;
  lastAudioPlayed = audioUrl;

  const onEnded = () => {
    audioPlayer.removeEventListener("ended", onEnded);
    audioPlayer.removeEventListener("error", onError);
    audios.shift();
    playAudiosSequentiallyWithCallback(audios, chatId, playIcon, callback, 0);
  };

  const onError = () => {
    audioPlayer.removeEventListener("ended", onEnded);
    audioPlayer.removeEventListener("error", onError);

    if (retryCount < TTS_TRANSIENT_RETRY_DELAYS_MS.length) {
      setTimeout(() => {
        playAudiosSequentiallyWithCallback(
          audios,
          chatId,
          playIcon,
          callback,
          retryCount + 1
        );
      }, TTS_TRANSIENT_RETRY_DELAYS_MS[retryCount]);
      return;
    }

    audios.shift();
    playAudiosSequentiallyWithCallback(audios, chatId, playIcon, callback, 0);
  };

  audioPlayer.addEventListener("ended", onEnded);
  audioPlayer.addEventListener("error", onError);

  audioPlayer.play().catch((err) => {
    console.warn(
      "autoPlayMessage: Autoplay blocked, waiting for user interaction",
      err
    );
    setPlayIconState(playIcon, false);
    callback();
  });
}

function playAudio(submitBtn) {
  // Prevent rapid double-clicks (stop → play loop)
  const now = Date.now();
  if (now - lastClickTime < 400) return;
  lastClickTime = now;

  let chatId = submitBtn.closest(".g-chatform").attr("id");
  let messageId = submitBtn.closest(".g-chatform-message").attr("data-id");

  if (
    $(".g-chatform-message-play").hasClass("is-playing") ||
    $(".g-chatform-message-play").hasClass("is-loading")
  ) {
    setPlayIconState($(".g-chatform-message-play"), false);
    TTSManager.stopSpeech();

    if (speechAudioPlayer[chatId]) {
      speechAudioPlayer[chatId].pause();
    }

    if (lastAudioPlayed) {
      let previousAudio = new Audio(lastAudioPlayed);
      previousAudio.pause();
    }

    // Always stop (don't restart) when clicking the actively-playing message
    if (lastMessageId === messageId) {
      return;
    }
  }

  if (
    submitBtn.hasClass("is-loading") ||
    submitBtn.hasClass("is-playing") ||
    submitBtn.hasClass("is-disabled")
  ) {
    return;
  }

  submitBtn.addClass("is-loading");

  lastMessageId = messageId;

  /**
   * Analytics
   */
  if (typeof growtypeAnalyticsCapture === "function") {
    growtypeAnalyticsCapture(
      "growtype_analytics_growtype_chat_action_clicked",
      {
        title: "play_message",
      }
    );
  }

  const selectedVoice = submitBtn
    .closest(".g-chatform")
    .find('select[name="tts_model_used"]')
    .val();

  if (TTSManager.supports(selectedVoice)) {
    const msgEl = submitBtn.closest(".g-chatform-message");
    let rawText =
      msgEl.attr("data-raw-text") ||
      msgEl.find(".g-chatform-message-content-inner").text() ||
      "";
    if (rawText.trim().length > 0) {
      TTSManager.speakText(rawText.trim(), submitBtn, null, selectedVoice);
      return;
    }
  }

  jQuery.ajax({
    url: growtype_chat_ajax.url,
    type: "post",
    data: {
      message_id: messageId,
      action: growtype_chat_ajax.play_message_action,
      nonce: growtype_chat_ajax.nonce,
      tts_model_override: submitBtn.data("tts-model-override") || "",
    },
    success: function (response) {
      submitBtn.removeClass("is-loading");

      // Keep logical-failure handling for compatibility with cached or legacy
      // endpoints that may still return the WordPress envelope with HTTP 200.
      if (response?.success === false) {
        setPlayIconState(submitBtn, false);
        handleAjaxError({ responseJSON: response }, submitBtn);
        return;
      }

      if (response.data && response.data.audios) {
        playAudiosSequentially(response.data.audios, submitBtn);
      } else {
        setPlayIconState(submitBtn, true);
      }

      /**
       * Update credits
       */
      updateCredits(response.data.existing_credits);
    },
    error: function (response) {
      submitBtn.removeClass("is-loading");
      setPlayIconState(submitBtn, false);

      const data = response.responseJSON?.data;

      if (data?.message === "voice_unavailable" && data?.fallback_voices) {
        showVoiceFallbackPicker(
          submitBtn,
          data.description,
          data.fallback_voices,
          messageId
        );
        return;
      }

      handleAjaxError(response, submitBtn);
    },
  });
}

function playAudiosSequentially(audios, submitBtn = null, params = {}) {
  let chatId = submitBtn ? submitBtn.closest(".g-chatform").attr("id") : null;

  if (!audios || audios.length === 0) {
    if (submitBtn) {
      submitBtn.removeClass("is-loading");
      setPlayIconState(submitBtn, false);
    }
    return;
  }

  const audioPlayer = speechAudioPlayer[chatId];
  if (!audioPlayer) {
    if (submitBtn) {
      submitBtn.removeClass("is-loading");
      setPlayIconState(submitBtn, false);
    }
    return;
  }

  const retryCount = Number(params.ttsRetryCount || 0);
  const audioUrl = retryCount > 0 ? ttsRetryUrl(audios[0]) : audios[0];

  if (lastAudioPlayed !== audioUrl) {
    audioPlayer.src = audioUrl;
    lastAudioPlayed = audioUrl;
  }

  audioPlayer.volume = params.muted ? 0 : 1;

  if (params.reset) {
    audioPlayer.pause();
    audioPlayer.currentTime = 0;
  }

  // Show pause icon while audio is playing
  if (submitBtn) {
    submitBtn.removeClass("is-loading");
    setPlayIconState(submitBtn, true);
  }

  // Use named handlers so we can remove them and prevent listener stacking
  const onEnded = () => {
    audioPlayer.removeEventListener("ended", onEnded);
    audioPlayer.removeEventListener("error", onError);
    audios.shift();
    playAudiosSequentially(audios, submitBtn, params);
  };

  const onError = () => {
    audioPlayer.removeEventListener("ended", onEnded);
    audioPlayer.removeEventListener("error", onError);

    if (retryCount < TTS_TRANSIENT_RETRY_DELAYS_MS.length) {
      setTimeout(() => {
        playAudiosSequentially(audios, submitBtn, {
          ...params,
          ttsRetryCount: retryCount + 1,
        });
      }, TTS_TRANSIENT_RETRY_DELAYS_MS[retryCount]);
      return;
    }

    audios.shift();
    playAudiosSequentially(audios, submitBtn, {
      ...params,
      ttsRetryCount: 0,
    });
  };

  audioPlayer.addEventListener("ended", onEnded);
  audioPlayer.addEventListener("error", onError);

  // 🔹 Play audio and handle Safari autoplay issues
  const playPromise = audioPlayer.play();

  if (playPromise !== undefined) {
    playPromise
      .then(() => {})
      .catch(() => {
        document.addEventListener(
          "click",
          () => {
            try {
              const retryPlayPromise = audioPlayer.play();
              if (
                retryPlayPromise &&
                typeof retryPlayPromise.catch === "function"
              ) {
                retryPlayPromise.catch(function () {});
              }
            } catch (error) {
              // A browser may reject playback synchronously.
            }
          },
          { once: true }
        );
      });
  }
}

/**
 * Show a Bootstrap modal when a Hume AI voice is unavailable.
 * Features: per-voice preview, select-to-save, updates the settings dropdown.
 *
 * @param {jQuery} submitBtn      - The play button that was clicked
 * @param {string} description    - Error description from server
 * @param {Object} fallbackVoices - keyed voice objects from Cartesia { label, preview_url, ... }
 * @param {string} messageId      - The message ID to replay after voice selection
 */
function showVoiceFallbackPicker(
  submitBtn,
  description,
  fallbackVoices,
  messageId
) {
  const MODAL_ID = "gc-voice-fallback-modal";

  // Remove any previous modal instance
  $("#" + MODAL_ID).remove();
  $("body").find(".modal-backdrop").remove();

  // Track currently previewing audio
  let previewAudio = null;

  function stopPreview() {
    if (previewAudio) {
      previewAudio.pause();
      previewAudio.currentTime = 0;
      previewAudio = null;
    }
    const $modal = $("#" + MODAL_ID);
    $modal.find(".gc-vfp-voice-card").removeClass("is-previewing");
    $modal
      .find(".gc-vfp-btn-preview")
      .removeClass("is-playing")
      .find('[data-state="play"]')
      .show()
      .end()
      .find('[data-state="pause"]')
      .hide();
  }

  // Build voice cards
  const voiceCards = Object.entries(fallbackVoices)
    .map(([key, v]) => {
      const hasPreview = v.preview_url ? "" : 'style="display:none"';
      return `
            <div class="gc-vfp-voice-card" data-voice-key="${key}" data-preview-url="${
        v.preview_url || ""
      }">
                <div class="gc-vfp-voice-info">
                    <span class="gc-vfp-voice-name">${v.label ?? key}</span>
                </div>
                <div class="gc-vfp-voice-actions">
                    <button class="gc-vfp-btn-preview" type="button" aria-label="Preview voice" ${hasPreview}>
                        <i class="fa-regular fa-circle-play" data-state="play"></i>
                        <i class="fa-solid fa-pause" data-state="pause" style="display:none"></i>
                    </button>
                    <button class="gc-vfp-btn-select" type="button">Select</button>
                </div>
            </div>`;
    })
    .join("");

  const modalHtml = `
        <div class="modal fade" id="${MODAL_ID}" tabindex="-1" aria-modal="true" role="dialog">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content gc-vfp-modal-content">
                    <div class="modal-header gc-vfp-modal-header">
                        <h5 class="modal-title">⚠️ Voice Unavailable</h5>
                        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body gc-vfp-modal-body">
                        <p class="gc-vfp-description">${
                          description ??
                          "This voice is currently unavailable. Choose a replacement from Cartesia:"
                        }</p>
                        <div class="gc-vfp-voice-list">${voiceCards}</div>
                    </div>
                </div>
            </div>
        </div>`;

  $("body").append(modalHtml);

  // Inject styles once
  if (!document.getElementById("gc-vfp-styles")) {
    const style = document.createElement("style");
    style.id = "gc-vfp-styles";
    style.textContent = `
            #gc-voice-fallback-modal .gc-vfp-modal-content {
                background: #0f0f12;
                border: 1px solid rgba(255,255,255,0.1);
                border-radius: 24px;
                overflow: hidden;
                color: #fff;
            }
            #gc-voice-fallback-modal .gc-vfp-modal-header {
                border-bottom: 1px solid rgba(255,255,255,0.08);
                padding: 16px 20px;
                background: linear-gradient(180deg, rgba(255,255,255,0.03) 0%, transparent 100%);
            }
            #gc-voice-fallback-modal .gc-vfp-modal-header .modal-title {
                font-size: 15px;
                font-weight: 600;
                color: #fff;
            }
            #gc-voice-fallback-modal .gc-vfp-modal-body { padding: 20px; }
            #gc-voice-fallback-modal .gc-vfp-description {
                font-size: 13px;
                color: rgba(255,255,255,0.6);
                margin-bottom: 16px;
            }
            #gc-voice-fallback-modal .gc-vfp-voice-list { display: flex; flex-direction: column; gap: 8px;max-height: 400px;overflow: scroll; }
            #gc-voice-fallback-modal .gc-vfp-voice-card {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 10px 14px;
                border-radius: 12px;
                background: rgba(255,255,255,0.04);
                border: 1px solid rgba(255,255,255,0.08);
                transition: background 0.15s, border-color 0.15s;
            }
            #gc-voice-fallback-modal .gc-vfp-voice-card:hover {
                background: rgba(255,255,255,0.07);
                border-color: rgba(255,255,255,0.15);
            }
            #gc-voice-fallback-modal .gc-vfp-voice-card.is-previewing {
                border-color: var(--primary-color, #ff6b6b);
                background: color-mix(in srgb, var(--primary-color, #ff6b6b) 10%, transparent);
            }
            #gc-voice-fallback-modal .gc-vfp-voice-info { display: flex; flex-direction: column; gap: 2px; }
            #gc-voice-fallback-modal .gc-vfp-voice-name { font-size: 13px; font-weight: 500; color: #fff; }
            #gc-voice-fallback-modal .gc-vfp-voice-actions { display: flex; align-items: center; gap: 8px; }
            #gc-voice-fallback-modal .gc-vfp-btn-preview {
                background: none;
                border: none;
                color: rgba(255,255,255,0.5);
                cursor: pointer;
                font-size: 18px;
                padding: 2px;
                transition: color 0.15s;
            }
            #gc-voice-fallback-modal .gc-vfp-btn-preview:hover { color: rgba(255,255,255,0.9); }
            #gc-voice-fallback-modal .gc-vfp-btn-preview.is-playing { color: var(--primary-color, #ff6b6b); }
            #gc-voice-fallback-modal .gc-vfp-btn-select {
                padding: 5px 14px;
                border-radius: var(--btn-primary-border-radius, 20px);
                border: 1px solid rgba(255,255,255,0.15);
                background: rgba(255,255,255,0.06);
                color: #fff;
                cursor: pointer;
                font-size: 12px;
                font-weight: 500;
                transition: background 0.15s, border-color 0.15s;
                white-space: nowrap;
            }
            #gc-voice-fallback-modal .gc-vfp-btn-select:hover {
                background: var(--btn-primary-background-color, var(--gc-main-color, #1877f2));
                border-color: transparent;
            }
            #gc-voice-fallback-modal .gc-vfp-btn-select.is-selected {
                background: var(--primary-color, #ff6b6b);
                border-color: transparent;
                color: #fff;
            }
        `;
    document.head.appendChild(style);
  }

  const $modal = $("#" + MODAL_ID);

  // === Voice preview ===
  $modal.on("click", ".gc-vfp-btn-preview", function () {
    const $btn = $(this);
    const $card = $btn.closest(".gc-vfp-voice-card");
    const previewUrl = $card.data("preview-url");

    if (!previewUrl) return;

    const isPlaying = $btn.hasClass("is-playing");
    stopPreview();

    if (!isPlaying) {
      previewAudio = new Audio(previewUrl);
      previewAudio
        .play()
        .then(() => {
          $btn.addClass("is-playing");
          $btn.find('[data-state="play"]').hide();
          $btn.find('[data-state="pause"]').show();
          $card.addClass("is-previewing");

          previewAudio.addEventListener("ended", () => {
            $btn.removeClass("is-playing");
            $btn.find('[data-state="play"]').show();
            $btn.find('[data-state="pause"]').hide();
            $card.removeClass("is-previewing");
            previewAudio = null;
          });
        })
        .catch(() => {
          previewAudio = null;
        });
    }
  });

  // === Voice select → save → retry ===
  $modal.on("click", ".gc-vfp-btn-select", function () {
    const $card = $(this).closest(".gc-vfp-voice-card");
    const voiceKey = $card.data("voice-key");

    stopPreview();

    // Mark selected
    $modal.find(".gc-vfp-btn-select").removeClass("is-selected").text("Select");
    $(this).addClass("is-selected").text("✓ Selected");

    // 1. Update the hidden <select name="tts_model_used"> in chat settings
    const $voiceSelect = submitBtn
      .closest(".g-chatform")
      .find('select[name="tts_model_used"]');

    // Add the Cartesia option if not already present (it may only show provider-filtered options)
    if ($voiceSelect.find(`option[value="${voiceKey}"]`).length === 0) {
      const v = fallbackVoices[voiceKey];
      $voiceSelect.append(
        $("<option>", {
          value: voiceKey,
          text: v.label ?? voiceKey,
          "data-preview-url": v.preview_url || "",
        })
      );
    }

    $voiceSelect.val(voiceKey);
    if ($.fn.chosen) $voiceSelect.trigger("chosen:updated");
    // Note: do NOT trigger 'change' here — that would fire the chatSettings auto-play handler

    // Also refresh the settings modal's voice dropdown to reflect the new selection
    const $settingsVoiceSelect = $(
      '.chat-settings select[name="tts_model_used"]'
    );
    console.error(
      "[VoiceFallback] settingsVoiceSelect found:",
      $settingsVoiceSelect.length
    );

    if ($settingsVoiceSelect.length) {
      const v = fallbackVoices[voiceKey];

      // Add option to settings select if missing
      if (
        $settingsVoiceSelect.find(`option[value="${voiceKey}"]`).length === 0
      ) {
        $settingsVoiceSelect.append(
          $("<option>", {
            value: voiceKey,
            text: v.label ?? voiceKey,
            "data-preview-url": v.preview_url || "",
          })
        );
      }

      // Update the setting value, enable the option if disabled, and save
      updateChatSettings("tts_model_used", voiceKey, true);

      // Update preview button URL
      const $voiceRow = $settingsVoiceSelect.closest(
        '.chat-settings-single[data-type="voice"]'
      );
      $voiceRow
        .find(".btn-preview-voice")
        .attr("data-preview-url", v.preview_url || "");

      // Re-filter voices by provider (now currentVal is the new voiceKey so correct provider shows)
      filterSettingsVoicesByProvider($settingsVoiceSelect);
    }

    // 3. Store voice override on the button so the AJAX call picks it up immediately
    //    (no need to wait for settings save to complete)
    submitBtn.data("tts-model-override", voiceKey);

    // 4. Close modal then retry — voice is passed directly, not from session
    $modal.one("hidden.bs.modal", () => {
      submitBtn.trigger("click");
    });
    $modal.modal("hide");
  });

  // Stop preview when modal closes
  $modal.on("hidden.bs.modal", function () {
    stopPreview();
    $(this).remove();
  });

  // Show modal
  $modal.modal("show");
}

// ============================================
// Provider-aware voice filtering in settings
// ============================================

/**
 * Get the TTS provider prefix from a voice key (e.g. "hume-female-x" → "hume")
 */
function getVoiceProvider(voiceKey) {
  if (!voiceKey) return null;
  return voiceKey.split("-")[0] ?? null;
}

/**
 * In the settings voice dropdown, show only voices matching the currently selected provider.
 * Call this on page load and whenever the voice changes externally.
 */
export function filterSettingsVoicesByProvider($select) {
  if (!$select || !$select.length) return;

  const currentVal = $select.val();
  const currentProvider = getVoiceProvider(currentVal);

  if (!currentProvider) return;

  $select.find("option").each(function () {
    const optionProvider = getVoiceProvider($(this).val());
    // Show voices matching this provider (or the currently selected value)
    $(this)
      .prop("disabled", optionProvider !== currentProvider)
      .toggle(optionProvider === currentProvider);
  });

  if ($.fn.chosen) $select.trigger("chosen:updated");
}
